module.exports = __webpack_public_path__ + "img/img-2.50e8dac4.webp";